import {Component, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {TechnicalDeviceNamespace} from '@namespaces/technical-device.namespace';
import {ConclusionFormDataService} from '../../services/conclusion-form-data.service';
import {Conclusion} from '@namespaces/conclusion.namespace';
import SignerSelectValue = Conclusion.SignerSelectValue;
import SignerFormStructure = Conclusion.SignerFormStructure;

/**
 * Форма подписантов
 */

@Component({
  selector: 'app-conclusion-form-signers',
  templateUrl: './conclusion-form-signers.component.html',
  styleUrls: ['./conclusion-form-signers.component.scss']
})
export class ConclusionFormSignersComponent implements OnInit {
    public showMessage = false;

    public technicalCard: TechnicalDeviceNamespace.ElementGroupTechcardInterface;

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private formDataService: ConclusionFormDataService,
    ) {

    }

    ngOnInit() {
        this.technicalCard = this.formDataService.technicalCard;

        /**
         * Отображаем сообщение, если нет ни одного специалиста и при этом есть хотя бы один селект, где спеца нужно выбрать
         */
        this.showMessage = !this.formDataService.specialists.length && this.formDataService.signersStructure.some(s => !s.free_input);
    }

    get specialists(): SignerSelectValue[] {
        return this.formDataService.specialists;
    }

    get formStructure(): SignerFormStructure[] {
        return this.formDataService.signersFormStructure;
    }
}
